import {
  FlexibleBlockBrickProcessState,
  FlexibleBlockBrickText,
  FlexibleBlockBrickTitle,
  FlexibleBlockProps,
  FlexibleBlockTemplateProcessState,
  PortalTextType,
  TailwindCommonPalette,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils';
import { brickCommon } from './common';

export const getProcessStateBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateProcessState>[] => {
  let index = -1;

  const brickProcessState: FlexibleBlockBrickProcessState = {
    ...brickCommon,
    brickName: 'Progress bar',
    brickType: 'process-state',
    relatedMenuItemId: '',
    theme: {
      text: {
        main: PortalTextType.SURFACE,
      },
      bg: {
        surface: [TailwindCommonPalette.SLATE_100],
        completed: [TailwindCommonPalette.GREEN_500],
      },
    },
    index: ++index,
  };

  const brickHeading: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Heading',
    text: 'Process progress',
    placeholder: 'Add a heading',
    className: ['text-lg', 'font-bold', 'pb-2'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++index,
    switchable: true,
  };

  const brickDescription: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Description',
    placeholder: 'Provide an overview or additional details about the onboarding steps.',
    text: 'Follow the process! Each step will guide you through the necessary actions to achieve your goal.',
    switchable: true,
    enabled: true,
    theme: {
      text: {
        main: PortalTextType.SURFACE,
      },
    },
    className: ['pb-0'],
    index: ++index,
  };

  return [
    {
      title: 'Process progress',
      template: {
        type: 'process-state',
        view: 'basic',
      },
      bricks: [brickProcessState, brickHeading, brickDescription],
      wrapper: { ...getWrapperProps('custom'), showTitle: false, className: ['p-6'] },
      className: [],
    },
  ];
};
